var LimitExerciseConst = {}
LimitExerciseConst.type = {
	[1] : "降级区",
	[2] : "保级区",
	[3] : "升级区",
}
module.exports = LimitExerciseConst